// JS file for NewsList
